import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';
import hoursToDuration from 'utils/hours-to-duration';
import { TOTAL_PAID_HOURS, TOTAL_PIECE_RATE_HOURS } from './constants';

interface Props {
    children: React.Node | Function;
    value: string | number;
}

export class FormTimesheetEntryValue extends React.PureComponent<Props> {
    render() {
        const { value, children, cellName } = this.props;
        if (!value && typeof value !== 'boolean') return null;
        if (!children) {
            if (cellName === TOTAL_PAID_HOURS || cellName === TOTAL_PIECE_RATE_HOURS) {
                return hoursToDuration(value);
            }
            return value;
        }
        return typeof children === 'function' ? children(value) : children;
    }
}

const mapStateToProps = createStructuredSelector({
    value: makeSelectValuesTimesheetEntryValue()
});

export default connect(mapStateToProps)(FormTimesheetEntryValue);
